var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300.597,
    height: 160.95,
    viewBox: "0 0 837.597 214.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Color",
    "data-name": "Logo / Color",
    transform: "translate(-59 -0.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M43.284,141.811c1.2,24.172,21.5,36.71,55.822,36.71h4.778c32.244,0,47.468-9.244,47.468-23.875,0-13.429-11.04-21.5-38.209-25.982l-38.357-5.372C26.412,114.939,5.832,98.824,5.832,61.8,5.832,28.668,34.485,0,94.491,0c57.6,0,92.533,26.279,96.717,68.672H147.925c-2.686-20.3-21.5-32.244-51.059-32.244H92.1c-28.371,0-44.783,9.853-44.783,22.688,0,14.334,9.556,20.893,33.134,24.78L119.7,89.268c48.67,8.057,73.154,29.558,73.154,63.88,0,40-32.541,61.8-91.064,61.8C38.8,214.95,1.187,190.17,0,141.811Z",
    transform: "translate(59 0.311)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M0,0H178.818V36.428H51.638A10.443,10.443,0,0,0,41.192,46.875V89.268H162.1v36.414H51.638a10.452,10.452,0,0,0-10.446,10.446V208.97H0Z",
    transform: "translate(272.513 3.301)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M208.97,0H158.683l-54.2,77.412L50.288,0H0L68.969,98.5a10.494,10.494,0,0,1,0,11.989L0,208.97H50.288l54.19-77.4,54.2,77.4H208.97l-68.954-98.483a10.444,10.444,0,0,1,0-11.989Z",
    transform: "translate(463.986 3.301)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(-428.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    "data-name": "Fill 13",
    d: "M0,0V41.8H31.339A10.443,10.443,0,0,1,41.785,52.246V83.6h41.8V0Z",
    transform: "translate(1241.861 3.301)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M0,41.8H41.8V0H0Z",
    transform: "translate(1116.478 170.477)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    "data-name": "Fill 15",
    d: "M167.185,156.739V125.4H135.846A10.455,10.455,0,0,1,125.4,114.939V83.6H94.046A10.443,10.443,0,0,1,83.6,73.154V41.8H52.246A10.443,10.443,0,0,1,41.8,31.354V0H0V83.6H31.354A10.443,10.443,0,0,1,41.8,94.046V125.4H73.154A10.452,10.452,0,0,1,83.6,135.846v31.339h31.339A10.465,10.465,0,0,1,125.4,177.631v31.354h83.585v-41.8H177.646a10.446,10.446,0,0,1-10.461-10.446",
    transform: "translate(1116.467 3.293)",
    fill: "#c9c9c9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDefaultImage);
export default __webpack_public_path__ + "static/media/EventDefaultImage.c61a128233ee5144bd6aa3d1a30cd2bc.svg";
export { ForwardRef as ReactComponent };